<template>
    <div class="taskDetail_wrap">
        <el-page-header @back="$core.goBack" ></el-page-header>
        <div class="task_detail">
            <div class="flex-between title_wrap">
               <div ><i class="iconfont icon-baogao">&nbsp;任务详情</i></div>
               <div></div>
           </div>
           <div class="task_content">
               <div class="flex-between">
                   <div class="flex-start"><span>任务名称：</span><span>{{assignmentTitle}}</span></div>
                   <div class="flex-start line_rignt" ><span>评估方式：</span><span>{{evaluateType == '0'?'手动评估':'自动评估'}}</span></div>
               </div>
               <div class="flex-between">
                   <div class="flex-start "><span>截止时间：</span><span>{{stopTime}}</span></div>
                   <div class="flex-start line_rignt" v-if="evaluateType == '1'"><span>评估指标：</span><span>{{evaluateIndex}}</span></div>
               </div>
               
               <div class="flex-start task_text">
                   <span>任务内容：</span>
                   <span>
                        <div class="task_text_content" v-html="richText"></div>
                    </span>
                </div>
               <div class="flex-start"><span>任务文件：</span><a :href="taskFile[1]" style="color:#5277F7">{{taskFile[0]}}</a></div>
           </div>
        </div>
        <div class="task_commit">
            <div class="flex-between title_wrap">
               <div ><i class="iconfont icon-tijiao-">&nbsp;任务上交</i></div>
               <div></div>
           </div>
           <div class="flex-start upload_wrap" >
               <div>
                   <el-upload
                        :show-file-list="false"
                        :disabled="status == 3"
                        class="upload-demo"
                        :action="uploadFileUrl"
                        :on-success="uploadFile"
                        :headers="{token:tokenVal}"
                    >
                        <div class="upload_area">
                            <i class="el-icon-folder-add"></i>
                            <div>点击上传文件</div>
                        </div>
                        <div slot="tip" class="el-upload__tip">再次上传任务文件将会覆盖之前的文件</div>
                    </el-upload>
                    <a :href="fileList[1]">{{fileList[0]}}</a>
                </div>
                <div>
                    <el-upload
                        :show-file-list="false"
                        v-if="evaluateType == '1'"
                        :disabled="status == 3"
                        class="upload-demo"
                        :action="uploadCodeUrl"
                        :headers="{token:tokenVal}"
                        :on-success="uploadCode"
                    >
                    <div class="upload_area" >
                        <i class="iconfont icon-code"></i>
                        <div>点击上传代码</div>
                    </div>
                    <div slot="tip" class="el-upload__tip">再次上传代码文件将会覆盖之前的文件</div>
                    </el-upload>
                    <a :href="codeList[1]">{{codeList[0]}}</a>
                    
                </div>
              
           </div>
        </div>
    </div>
</template>

<script>
import { getAssignment } from '../../../utils/api';
    export default {
        data(){
            return{
                taskId:this.$route.query.taskId,
                uploadFileUrl:this.$config.SYSTEM_URL + `/msdata/assignment/student/uploadFile?assignmentId=${this.$route.query.taskId}`,
                uploadCodeUrl:this.$config.SYSTEM_URL + `/msdata/assignment/student/uploadCode?assignmentId=${this.$route.query.taskId}`,
                tokenVal:sessionStorage.getItem('token'),
                assignmentTitle:'',
                evaluateIndex:'',
                stopTime:'',
                evaluateType:'',
                richText:'',
                taskFile:['',''],
                fileList:['',''],
                codeList:['',''],
                status:''
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
            this.getTaskDetail()
        },
        methods: {
            //获取任务细节
            getTaskDetail(){
                getAssignment({assignmentId:this.taskId}).then(res => {
                    this.assignmentTitle = res.data.assignmentTitle
                    this.evaluateType = res.data.evaluateType
                    this.evaluateIndex = res.data.evaluateIndex
                    this.richText = res.data.richText
                    this.stopTime = res.data.stopTime
                    this.status = res.data.status
                    res.data.fileUrl && (this.taskFile = [decodeURIComponent(res.data.fileUrl).split('/').pop().substr(13),res.data.fileUrl])
                    res.data.answerUrl && (this.fileList = [decodeURIComponent(res.data.answerUrl).split('/').pop().substr(13),res.data.answerUrl])
                    res.data.codeUrl && (this.codeList = [decodeURIComponent(res.data.codeUrl).split('/').pop().substr(13),res.data.codeUrl])
                    //设置富文本中图片的大小
                    this.richText = this.richText.replace(/<img/g,"<img style='max-width:100%;height:auto;'");

                }).catch(err => {})
            },

            //上传任务文件
            uploadFile(res, file){
                if(res.status != 200) return this.$message.error(res.message)
                let arr = []
                arr[0] = file.name
                arr[1] = res.data
                this.fileList = arr
                this.$message.success('文件上传成功')
            },

            //上传代码文件
            uploadCode(res, file){
                if(res.status != 200) return this.$message.error(res.message)
                let arr = []
                arr[0] = file.name
                arr[1] = res.data
                this.codeList = arr
                this.$message.success('代码上传成功')
            }
        }
    }
</script>

<style lang="scss" scoped>
.task_commit{
    margin: 0px 150px;
    padding: 25px 75px;
    background: white;
    margin-top: 30px;
        .upload_wrap{
            padding-left: 5%;
            padding-top: 50px;
            >div{
                text-align: center;
            }
            .upload_area{
                height: 150px;
                width: 150px;
                border: 1px dotted rgba(51,51,51,.5);
                border-radius: 10px;
                margin: 0px 60px 10px 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                i{
                    font-size: 30px;
                    margin-bottom: 8px;
                }
        }
        .upload_area:hover{
            color: #5277F7;
            cursor: pointer;
            border: 1px dotted #5277F7;
        }
       
    }
}
.task_detail{
    padding: 25px 75px;
    margin: 0px 150px;
    background: white;
    .task_content{
        padding: 20px 20% 20px 100px;
        box-sizing: border-box;
        .line_rignt{
            width: 300px;
        }
        .flex-between{
            .flex-start:nth-child(2){
                margin-right: 20%;
            }
        }
        .task_text{
            margin: 30px 0px;
            .task_text_content{
                max-width: 65vw;
                overflow: hidden;
            }
            
        }
        .flex-start{
            padding: 10px 0px;
            box-sizing: border-box;
            line-height: 1.7;
            color: #333;
            font-size: 20px;
            span:nth-child(1){
                width: 100px;
                white-space: nowrap;
                font-weight: bold;
            }
        }
    }
}
.taskDetail_wrap{
    background: #F3F6FF;
    padding: 40px 0px;
    .title_wrap{
        height: 70px;
        box-sizing: border-box;
        padding-left: 25px;
        i{
            font-size: 28px;
            color: #5277F7;
            font-weight: bold;
        }
    }
}

</style>

